// Quem abre cada monitoramento (TRI-107; o admin passa). A rota dinâmica atende todos os monitores,
// então as roles vêm do `monitoramentoUrl`. Aplicado pelo guard de @/router/permissoes.js, que o menu
// lateral também usa. Monitor sem entrada no mapa fica com ROLES_MONITORAMENTO.
const ROLES_MONITORAMENTO = ['operacional_prana']
const ROLES_POR_MONITORAMENTO = {
    'processo-sem-invoice': ['operacional_prana', 'colaborador_satya']
}
const rolesDoMonitoramento = (rota) => ROLES_POR_MONITORAMENTO[rota.params.monitoramentoUrl] ?? ROLES_MONITORAMENTO


const demurrageBreadCrumb = [
    {
        label: 'Monitoramento Demurrage',
        to: 'MonitoramentoPrevisaoFaturamentoMensal',
        params: { monitoramentoUrl: 'demurrage' }
    }
]

export default [
    {
        path: '/monitoramentos/:monitoramentoUrl',
        name: 'MonitoramentoPrevisaoFaturamentoMensal',
        component: () => import('@/views/Monitoramentos/MonitoramentoListPage.vue'),
        meta: {
            roles: rolesDoMonitoramento,
            title: 'Monitoramento',
            breadcrumb: [
                { label: 'Monitoramento Demurrage', to: 'MonitoramentoPrevisaoFaturamentoMensal' }
            ]
        }
    },
    {
        path: '/monitoramentos/demurrage/novo',
        name: 'MonitoramentoDemurrageNovo',
        component: () => import('@/views/Monitoramentos/Demurrage/NovoMonitoramentoDemurragePage.vue'),
        meta: {
            roles: ROLES_MONITORAMENTO,
            title: 'Novo Registro de Demurrage',
            breadcrumb: [
                ...demurrageBreadCrumb,
                { label: 'Novo Registro' }
            ]
        }
    },
    {
        path: '/monitoramentos/demurrage/:id/detalhe',
        name: 'MonitoramentoDemurrageDetalhes',
        component: () => import('@/views/Monitoramentos/Demurrage/NovoMonitoramentoDemurragePage.vue'),
        meta: {
            roles: ROLES_MONITORAMENTO,
            title: 'Detalhes do Registro de Demurrage',
            breadcrumb: [
                ...demurrageBreadCrumb,
                { label: 'Detalhes' }
            ]
        }
    },
];
